import React, { useCallback, useState, useRef, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux'
import * as a from 'actions/livefeedapi';
import { setEditorDefaultState } from 'actions/livefeed';
import moment from 'moment';
import config from "config";
import Modal from "components/common/modal";
import ReactTooltip from "react-tooltip";
import ReactTable from "react-table";

const TemplateTableList = (props) => {
    const deleteTemplateModal = useRef(null);
    const [componentState, setComponentState] = useState({})

    const dispatch = useDispatch();
    const { templates } = useSelector(state => state.livefeedAPIReducer)
    const user = useSelector(state => state.myAccountReducer.user)
    const isAdmin = user.role === config.roles[0].rolecode
    useEffect(() => {
        ReactTooltip.rebuild()// componentDidUpdate()
    })

    const deleteTemplate = useCallback((templateId, fClose) => {
        dispatch(a.deleteTemplate(templateId, fClose));
    }, [dispatch])

    const openEditor = useCallback((index) => {
        dispatch(setEditorDefaultState())
        var template = templates[index];

        const { id, data, name } = template
        let passedData = data;
        passedData.livefeedName = name
        props.router.push({
            pathname: '/livefeed/editor',
            state: {
                mode: "editTemplate",
                key: id,
                passedData: passedData,
                templateList: templates
            }
        });
    }, [dispatch, props.router, templates])


    function makehandlerDelete(index) {
        let currentTemplate = templates[index]

        setComponentState({
            deletedTemplateId: currentTemplate.id,
            deletedTemplateName: currentTemplate.name,
        })

        deleteTemplateModal.current.open();
    }
    //------------------------------------------- CRUD btns fn Render -----------------------------------
    function renderCellBtn(child) {
        return (
            <div className="livefeed-child livefeed-child_icons">
                {child}
            </div >
        )
    }
    const editDeleteBtns = (index) =>
        <Fragment>
            {renderCellBtn(
                <i className="material-icons edit--icons" data-tip="Edit template"
                    onClick={() => { openEditor(index) }}>edit</i>
            )}
            {renderCellBtn(
                <i className="material-icons delete--icons" data-tip="Delete"
                    onClick={() => makehandlerDelete(index)}>clear</i>
            )}
        </Fragment>
    //------------------------------------------- Collumns for table -----------------------------------
    const columns = [
        {
            Header: "Name", accessor: "name",
            Filter: ({ filter, onChange }) => (
                <input type='text' placeholder="Search template" value={filter ? filter.value : ''}
                    onChange={event => onChange(event.target.value)}
                />
            ),
            Cell: ({ value, index, original: { id } }) =>
                <div data-tip={`${isAdmin ? 'Create new livefeed using this template' : ''}`}
                    onClick={() => {
                        if (isAdmin) {
                            let passedData = templates[index].data;
                            passedData.livefeedName = templates[index].name
                            props.router.push({
                                pathname: '/livefeed/editor',
                                state: {
                                    mode: "createLivefeed", key: id, passedData: passedData, templateList: templates
                                }
                            })
                        }
                    }}
                    className={`livefeed-child ${isAdmin ? 'livefeed-child_name' : ''}`}>
                    <span className="ellipsis">{value}</span>
                </div>
        },
        {
            width: 200, Header: "Creator", accessor: "data.owner",
            Cell: ({ value }) =>
                <div className="livefeed-child">
                    <span className="ellipsis">{value}</span>
                </div>
        },
        {
            id: "date", width: 180, Header: "Date",
            accessor: ({ data }) => data.timestamp,
            Cell: ({ value }) =>
                <div className="livefeed-child">
                    <span className="ellipsis">
                        {moment(value).local().format("DD-MM-YYYY HH:mm:ss")}
                    </span>
                </div>
        },
        {
            Header: "Actions", width: 100, style: { padding: 0, height: 44 }, filterable: false, sortable: false, resizable: false,
            Cell: ({ index }) =>
                <div className="livefeed-crud">
                    {isAdmin ?
                        <Fragment>
                            {editDeleteBtns(index)}
                        </Fragment> :
                        <span className="livefeed-child_disabled" data-tip='Only Admins can edit and delete'>
                            {editDeleteBtns(index)}
                        </span>
                    }
                </div>
        }
    ]
    const addNewTemplate = useCallback(() => {
        dispatch(setEditorDefaultState()),
            props.router.push({
                pathname: '/livefeed/editor',
                state: {
                    mode: "createTemplate"
                }
            })
    }, [dispatch, props.router])
    return (
        <Fragment>
            <h3 className="live-feed-title">Templates</h3>
            <div data-tip={`${!isAdmin ? 'Only Admins can add' : ''}`}
                className={`button btn--green add-livefeed-btn ${!isAdmin ? 'add-livefeed-btn_disabled' : ''}`}

                onClick={() => isAdmin ? addNewTemplate() : null}>
                <span className="font-icon icon-addicon" />
                Add Template
            </div>

            <div className="all-feed-container">
                {templates.length > 0 ?
                    <Fragment>
                        <ReactTooltip place="top" type="dark" effect="solid" />
                        <ReactTable
                            data={templates}
                            columns={columns}
                            style={{
                                height: "400px" // This will force the table body to overflow and scroll, since there is not enough room
                            }}
                            filterable
                            defaultSorted={[
                                {
                                    id: "date",
                                    desc: true
                                }
                            ]}
                            defaultPageSize={10}
                            className="-highlight livefeed-list-table"
                        />
                    </Fragment>
                    : <div>No template has been saved yet.</div>
                }

                <Modal
                    ref={deleteTemplateModal}
                    clickButton={() => { deleteTemplate(componentState.deletedTemplateId, deleteTemplateModal.current.close()) }}
                    header="Delete template"
                    buttonText="Delete"
                    buttonClass="btn-danger"
                    entry={null}
                >
                    <div className="delete-template-modal">
                        Are you sure you want to delete template
                                <b> {componentState.deletedTemplateName}</b>?
                            </div>
                </Modal>
            </div>
        </Fragment >
    );
}
TemplateTableList.propTypes = {
    router: PropTypes.any.isRequired
}
export default TemplateTableList



// WEBPACK FOOTER //
// ./src/components/pages/livefeed/SwitchTab/TemplateTableList/index.jsx